import ArticleList from "../components/alert/ArticleList.vue";
import GlobalVue from "../globalVue";
import BindGoods from "../page/client/BindGoods.vue";
var ExceptionTypes = {
    EXISTS_PENDING_INVENTORY_ORDER: 3,
    EXISTS_PENDING_STOCK_INIT_ORDER: 4,
    EXISTS_PENDING_WAREHOUSE_ORDER: 5,
    EXISTS_PENDING_SORTING_ORDER: 6,
    EXISTS_PENDING_TRANSFER_ORDER: 7,
    BUSINESS_GOODS_NOT_BIND: 8,
    GOODS_STOCK_IS_SHORT: 9,
};
var handleException = function (that, res, business_data) {
    var code = res.code;
    var resData = res.data;
    console.log('exception', res, business_data);
    switch (code) {
        case ExceptionTypes.BUSINESS_GOODS_NOT_BIND:
            var instance = that.$dialog(ArticleList, {
                data: {
                    resData: res,
                    sureButtonText: '去绑定',
                    modelType: 'deliver',
                }
            }, {
                title: "提示",
                width: 450,
                height: 350
            }).instance;
            instance.$on("addClient:ok", function (data) {
                var listData = res.data;
                var goodCodes = [];
                listData.forEach(function (v) {
                    goodCodes = goodCodes.concat(v.codes);
                });
                goodCodes = goodCodes.join(' ');
                var business_id = business_data.business_id.toString();
                var supplier_to_business_id = business_data.supplier_to_business_id.toString();
                GlobalVue.$emit("addTab", {
                    component: BindGoods,
                    title: '绑定货品',
                    showExist: true,
                    name: 'bindGoods_' + business_id,
                    cprops: {
                        clientIds: business_id,
                        business_id: business_id,
                        supplier_to_business_id: supplier_to_business_id,
                        supplierToBusinessIds: supplier_to_business_id,
                        good_code: goodCodes
                    }
                });
            });
            break;
        default:
    }
};
export { ExceptionTypes, handleException };
